import React, { useMemo } from 'react'
import Chart from './components/Chart'
import { validateSchema } from './validators'
import { schemaMap } from './constants'

const FactoryKPIsChart = (props) => {
  const { type, data, color, config, legendLabels, size } = props

  // Check for the element and the validation schema, given the type
  const { Schema, Config } = useMemo(() => schemaMap[type] ?? {}, [type])

  // The given props are validated based on the type
  const error = useMemo(() => validateSchema(Schema, props), [Schema, props])

  if (error) {
    console.error(error)
    return null
  }
  return (
    <Chart
      {...props}
      config={Config({ config, data, color, legendLabels, size })}
    />
  )
}

export { FactoryKPIsChart as default }
